/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActivityWithImpactResponse } from '../../models/activity-with-impact-response';

export interface DataAnalyticsImpacts$Params {
  count: number;
  days: number;
}

export function dataAnalyticsImpacts(http: HttpClient, rootUrl: string, params: DataAnalyticsImpacts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityWithImpactResponse>>> {
  const rb = new RequestBuilder(rootUrl, dataAnalyticsImpacts.PATH, 'get');
  if (params) {
    rb.path('count', params.count, {});
    rb.path('days', params.days, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ActivityWithImpactResponse>>;
    })
  );
}

dataAnalyticsImpacts.PATH = '/rest/data-analytics/impacts/{count}/{days}';
